import { render, staticRenderFns } from "./OptimCreate.vue?vue&type=template&id=34a5c55d&lang=html&"
import script from "./OptimCreate.vue?vue&type=script&lang=js&"
export * from "./OptimCreate.vue?vue&type=script&lang=js&"
import style0 from "./OptimCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports